import clone from 'lodash/clone';

import { SIDEKICK_FETCH_TIMEOUT } from './sidekick_http_gateway';
import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

export default class SidekickExternalActionsHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/external-actions');
  }

  fetchAll(params, query, httpOptions) {
    const localParams = clone(params);
    const localQuery = clone(query);
    const url = this.buildUrl(this.endpoint.set(params).fetchAllUrl, query);
    const resource = this.endpoint.patterns.fetchAllUrl;

    const options = { ...httpOptions, timeout: SIDEKICK_FETCH_TIMEOUT };

    return this.http
      .get(url, options, resource)
      .then(dto => {
        this.observer.onFetchAllSuccess(dto, localParams, localQuery);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchAllError(error, localParams, localQuery);
        throw error;
      });
  }
}
